import { hashHistory } from 'react-router';

// Get 'app' path
import { path as APP_PATH } from '../..';

// All paths
const PATHS = {
  DEVICES: 'devices',
  INFORMATION: 'information',
  SIMCARD: 'simcard',
  LOGS: 'logs',
  DISTRIBUTIONS: 'distributions',
};

// Exported paths
export const MAIN_PATH = PATHS.DEVICES;
export const INFORMATION_PATH = PATHS.INFORMATION;
export const SIMCARD_PATH = PATHS.SIMCARD;
export const LOGS_PATH = PATHS.LOGS;
export const DISTRIBUTIONS_PATH = PATHS.DISTRIBUTIONS;

// Root
const APP_DEVICES_PATH = `${APP_PATH}/${MAIN_PATH}`;

export const listPath = () => APP_DEVICES_PATH;
export const navigateToList = () => {
  hashHistory.push(listPath());
};

export const showPath = (id) => `${APP_DEVICES_PATH}/${id}`;
export const navigateToShow = (id) => {
  hashHistory.push(showPath(id));
};

export const activatePath = () => `${APP_DEVICES_PATH}/activate`;
export const navigateToActivate = () => {
  hashHistory.push(activatePath());
};



// WEBPACK FOOTER //
// ./routes/app/routes/devices/navigation.js